<div class="content-with-stepper-and-title">
  <div class="row">
    <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <h2 class="title" id="residenceAbroadComponentTitle1" [innerHtml]="copyService.copies.residence_abroad_copies.title_1"></h2>
      <div *ngIf="district_option" class="spacing">
        <div class="box-input">
          <voxel-form-field id="providenceSelectionLabel" [label]="copyService.copies.residence_abroad_copies.providence_selection_label">
            <vcl-autocomplete id="providenceAutoCompleteComponent" [placeholder]="copyService.copies.residence_abroad_copies.providence_filter_placeholder" (change)="selectOptionProvidence($event)" required [notFoundTitle]="copyService.copies.residence_abroad_copies.filter_not_found_title" [notFoundMessage]="copyService.copies.residence_abroad_copies.filter_not_found_message">
              <vcl-option [id]="option.district_id" *ngFor="let option of district_option" [value]="option.district_id" [selected]="option.district_id === selected_district">
                {{ option.district }}
              </vcl-option>
            </vcl-autocomplete>
          </voxel-form-field>
        </div>
      </div>
      <div *ngIf="city_option">
        <div class="box-input">
          <voxel-form-field id="citySelectionLabel" [label]="copyService.copies.residence_abroad_copies.city_selection_label">
            <vcl-autocomplete id="autoCompleteComponent" [placeholder]="copyService.copies.residence_abroad_copies.filter_placeholder" (change)="selectOption($event)" required [notFoundTitle]="copyService.copies.residence_abroad_copies.filter_not_found_title" [notFoundMessage]="copyService.copies.residence_abroad_copies.filter_not_found_message">
              <vcl-option [id]="'citySelection' + option.city_code" *ngFor="let option of options" [value]="option" [selected]="option.city_code === selectedCity.city_code && option.province_code === selectedCity.province_code">
                {{ option.description }}
              </vcl-option>
            </vcl-autocomplete>
          </voxel-form-field>
        </div>
      </div>
      <br>
      <div class="box-input">
        <voxel-form-field id="EthnicGroupSelectionLabel" [label]="copyService.copies.ethnic_group_copies.group_ethnic_label">
          <vcl-autocomplete id="autoCompleteComponent" [placeholder]="copyService.copies.ethnic_group_copies.filter_placeholder" 
          required [multiLines]="multiLines" 
          (change)="selectOptions($event)" required [notFoundTitle]="copyService.copies.residence_abroad_copies.filter_not_found_title" [notFoundMessage]="copyService.copies.residence_abroad_copies.filter_not_found_message">
            <vcl-option [id]="'EthnicGroupSelection' + option.id" *ngFor="let option of optionss" 
            [selected]="option.id === selectedEthnicGroup.ethnic_group_code"[value]="option">
              {{ option.value }}
            </vcl-option>
          </vcl-autocomplete>
        </voxel-form-field>
      </div>
      <h2 class="title input-title" id="residenceAbroadComponentTitle2" [innerHtml]="copyService.copies.residence_abroad_copies.title_2"></h2>
      <div class="content-checkbox">
        <voxel-radio-button-group id="radioLiveAbroad">
          <voxel-radio-button *ngFor="let checkbox of checkboxList"
           [id]="checkbox.id" [checked]="checkbox.checked" 
           (radioButtonChange)="radioButtonChange($event)" 
           [value]="checkbox.value">
            {{checkbox.label}}
          </voxel-radio-button>
        </voxel-radio-button-group>
      </div>
    </div>
  </div>
  <app-controls id="residenceAbroadBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.residence_abroad_copies.button" (next)="next()" [nextDisabled]="enabledButton"></app-controls>
</div>
